const NAMESPACE = 'SOFTWAREACCESS';

const INITIAL_STATE: SoftwareAccessState = {
  isMechanicalDealer: false,
  isCollisionDealer: false,
  isMechanicalShop: false,
  isCollisionShop: false,
};

export const  SoftwareAccessActions = {
  INIT: `${NAMESPACE}.INIT`,
  SET_DEALER_SOFTWARE_ACCESS: `${NAMESPACE}.SET_DEALER_SOFTWARE_ACCESS`,
  SET_SHOP_SOFTWARE_ACCESS: `${NAMESPACE}.SET_SHOP_SOFTWARE_ACCESS`,
};

export function SoftwareAccessReducer(state: SoftwareAccessState = INITIAL_STATE, action: any) {
  const temp = {...state};
  switch (action.type) {
    case SoftwareAccessActions.INIT:
      return {...INITIAL_STATE};
    case SoftwareAccessActions.SET_DEALER_SOFTWARE_ACCESS:
      temp.isMechanicalDealer = action.payload.isMechanicalDealer;
      temp.isCollisionDealer = action.payload.isCollisionDealer;
      return temp;
    case SoftwareAccessActions.SET_SHOP_SOFTWARE_ACCESS:
      temp.isMechanicalShop = action.payload.isMechanicalShop;
      temp.isCollisionShop = action.payload.isCollisionShop;
      return temp;
    default:
      return temp;
  }
}

export interface SoftwareAccessState {
  isMechanicalDealer: boolean;
  isCollisionDealer: boolean;
  isMechanicalShop: boolean;
  isCollisionShop: boolean;
}
